import { ActionType, createAction } from 'typesafe-actions'
import { MessageState } from '../../types'
import { ReplyMessageState } from './types'

export const replyMessageAction = createAction('@message/REPLY_MESSAGE')<ReplyMessageState>()

const success = (state: MessageState, action: ActionType<typeof replyMessageAction>): MessageState => {
  return {
    ...state,
    replyMessage: action.payload.replyMessage
  }
}

export const replyHandle = { asyncAction: replyMessageAction, success }
